import { Injectable } from '@angular/core';
import { _Service } from './_service';
import { AppId, EudrCredential, EudrCredentialPublic, EudrCredentialWrite } from '../../model';

@Injectable({ providedIn: 'root' })
export class EudrCredentialService extends _Service<EudrCredential> {
  constructor() {
    super('api/admin/eudr-credential');
  }

  getPublic = async (id: AppId) => await this.http.get<EudrCredentialPublic>(`api/eudr-credential/${id}`);

  override create = async (data: EudrCredentialWrite) => await this.http.post<EudrCredential>(this.prefix, { ...data });
  override update = async (id: AppId, data: EudrCredentialWrite) =>
    await this.http.put<EudrCredential>(`${this.prefix}/${this.mapId(id)}`, { ...data });
}
